import api from './api';

export const getCompanyInfo = async () => {
    try {
        const response = await api.get('/company_info.php');
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const createCompanyInfo = async (data) => {
    try {
        const response = await api.post('/company_info.php', data);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const updateCompanyInfo = async (data) => {
    try {
        const response = await api.put('/company_info.php', data);
        return response.data;
    } catch (error) {
        throw error;
    }
};
